// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"276d8255","501":"0dacfc6b"}[chunkId] + ".chunk.js";
};